export interface Role {
  uuid: string;
  name: UserRole;
  description?: string;
  created_at: Date;
  updated_at: Date;
}

export enum UserRole {
  ADMIN        = 'admin',
  TEACHER      = 'teacher',
  STUDENT      = 'student',
  SUPER_ADMIN  = 'super_admin',
  NON_TEACHING = 'non_teaching'
}